const config = {
  administrator: '系統管理員',
  stage: '更改面試階段',
  language: '更改系統語言',
  set: '設置',
  log_out: '登出',
  logout_tip: '你確定要登出嗎?',
  msg_all_loaded: '已加載全部',
  msg_del_success: '通知已刪除!',
  msg_del_fail: '刪除失敗!',
  notice: '通知',
  ChangeRole: '所有角色',
  change_pwd: '更改密碼',
  required_old_pwd: '請輸入原密碼',
  required_new_pwd: '請輸入新密碼',
  required_confirm_pwd: '請輸入確認新密碼',
  change_successfully: '更改成功',
  change_failed: '修改失敗',
  old_password: '原密碼',
  new_password: '建立新密碼',
  confirm_password: '確認新密碼',
  save_change: '保存更改',
  _ChangeRole: '更改角色'
};

export default config;
